import { useState, useEffect, useRef } from "react";
import ExploreProjects from "../components/common/ExploreProjects";
import SponsorBanner from "../components/common/SponserBanner";
import ProjectsList from "../components/projects/ProjectsList";
import { getAllProjects } from "../service/MainService";
import { getProjectById } from "../service/MainService";
import { useNavigate } from "react-router-dom";



const Projects = () => {
  const [projects, setProjects] = useState([]);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(0);
  const topRef = useRef(null);
  const [filters, setFilters] = useState({});
  const [projectCount, setProjectCount] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const projectsData = await getAllProjects(currentPage, 12, filters);
        setProjects(projectsData.Result);
        setProjectCount(projectsData.TotalProjects);
        setLoading(false);
      } catch (error) {
        setError(error.message);
        setLoading(false);
      }
    };
    fetchData();
  }, [currentPage, filters]);

  const navigateToProjectDetail = async (projectId) => {
    try {
      const token = localStorage.getItem("accessToken");
      const projectDetails = await getProjectById(projectId, token);
      navigate(`/project/${projectId}`, {
        state: { projectDetails },
      });
    } catch (error) {
      console.error("Error fetching project details:", error);
    }
  };

  const handlePageChange = (page, e) => {
    e.preventDefault();
    setCurrentPage(page);
  };


  const handleFilterChange = (selectedFilters) => {
    setFilters(selectedFilters);
    console.log(selectedFilters);
  };

  const handleFilterChangeTypology = (selectedFilters) => {
      setFilters({typology: selectedFilters });
   
  };
  

  const typologies = [
    "Residential",
    "Commercial & Retail",
    "Cultural & Civic",
    "Industrial & Manufacturing Architecture",
    "Healthcare & Wellness Architecture",
    "Public Infrastructure & Civic Buildings",
    "Historical & Heritage Architecture",
    "Recreation & Sports Architecture",
    "Environmental & Sustainable Architecture",
    "Urban Planning & Master Planning",
    "Interior Design & Interiors",
    "Landscape Architecture & Design",
    "Temporary & Installation Architecture",
    "Emerging & Experimental Architecture",
    "Sustainability & Green Building",
  ];


  return (
    <>
      <div className="lg:px-40">
        <ProjectsList
          projects={projects}
          loading={loading}
          error={error}
          projectCount={projectCount}
          handleFilterChange={handleFilterChange}
          navigateToProjectDetail={navigateToProjectDetail}
          handlePageChange={handlePageChange}
          currentPage={currentPage}
          topRef={topRef}
        />
      </div>
      <div className="bg-gray-100 py-5 lg:px-40">
        <ExploreProjects title={"Explore Projects"} explore={typologies} onCategorySelect={handleFilterChangeTypology}/>
      </div>
      <div className="lg:px-40">
        <SponsorBanner />
      </div>
    </>
  );
};

export default Projects;
